import type { AxiosResponse } from 'axios';

import { NotificationsAnnouncements } from '@rover/rsdk/src/apiClient/latest';
import { getAxiosInstance } from '@rover/rsdk/src/modules/Network/axios';
import { camelize } from '@rover/rsdk/src/modules/Network/object-utilities';
import { fullApiUrl } from '@rover/utilities/apiUrl';

import 'axios';

import DefaultAPIErrorHandler from './DefaultAPIErrorHandler';

export const GET_NOTIFICATIONS_URL: string = fullApiUrl('announcements/notifications/');
export type NotificationsResponse = {
  count: number;
  unreadCount: number;
  results: NotificationsAnnouncements[];
  next?: string;
  previous?: string;
};
export const get = async (): Promise<AxiosResponse<NotificationsResponse>> => {
  const ai = getAxiosInstance();

  try {
    const res = await ai.get<string, AxiosResponse<NotificationsResponse>>(GET_NOTIFICATIONS_URL);
    res.data = camelize(res.data, true);
    return res;
  } catch (e: any) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while fetching the initial notifications.'
    );
  }
};
export const getNextPage = async (
  nextPageUrl: string
): Promise<AxiosResponse<NotificationsResponse>> => {
  const ai = getAxiosInstance();

  try {
    const res = await ai.get(nextPageUrl);
    res.data = camelize(res.data, true);
    return res;
  } catch (e: any) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while fetching the next page of notifications.'
    );
  }
};
export const read = async (url: string): Promise<void> => {
  const ai = getAxiosInstance();

  try {
    return await ai.patch(url, {
      read: true,
    });
  } catch (e: any) {
    return DefaultAPIErrorHandler(e, 'There was an error while marking the notification as read.');
  }
};
export const dismiss = async (url: string): Promise<void> => {
  const ai = getAxiosInstance();

  try {
    return await ai.patch(url, {
      is_dismissed: true,
    });
  } catch (e: any) {
    return DefaultAPIErrorHandler(
      e,
      'There was an error while marking the notification as dismissed.'
    );
  }
};
